export const commonEnvironment = {
  // local
  // rootUrl: 'http://localhost:3600/',

  // devlopment
  //rootUrl: 'https://dev-finance-api.dpworld.com/',

  // qa
  rootUrl: 'https://qa-finance-api.dpworld.com/',

  // staging
  // rootUrl: 'https://staging-finance-api.dpworld.com/',

  // uat
  // rootUrl: 'https://uat-finance-api.dpworld.com/',

  //demo environment
  //rootUrl: 'https://demo-finance-api.dpworld.com/',

  // special properties? ///////////////////////

  // development
  accountingModuleRootApiUrl: 'https://dev-finance-accounting-api.dpworld.com/',

  // development
  bhsModuleRootUrl: 'https://dev-finance-api.dpworld.com/api/auth/',

  apiValue: '7cf0e70059e5bfb3c37171cc7cd229cc', // prod
  productionHosting: false,

  noHeaderRoutes: ['login', 'register'],
  HEADER: {
    X_API_KEY: 'X-DPW-ApiKey',
    X_USER_TOKEN: 'X-DPW-User-Token',
    X_USER_REFRESH_TOKEN: 'X-DPW-Refresh-Token',
    X_USER_ID: 'X-User-Id',
    X_TRACE_CONTEXT: 'X-Trace-Context',
    X_CLIENT_SOURCE: 'X-Client-Source', // android-native, ios-native, android-web, ios-web web
    X_TOTAL_COUNT: 'X-Total-Count',
    X_DISPLAY_MODE: 'X-Display-Mode', // web, mobile
    AUTHORIZATION: 'Authorization',
    X_ORG_ID: 'X-Org-Id',
    X_TENANT_CODE: 'X-Tenant-Code'
  },

  versionOfDocumentForTerms: 2,
  versionOfDocumentForFi: 1,
  GTAG_ID: 'GTM-P7C5BCV',
  GTAG_ID_NON_PROD: 'GTM-P7C5BCV&gtm_auth=YS3JSt2rEVl7-V_f3ZAYCw&gtm_preview=env-4&gtm_cookies_win=x',

  DOCUMENT_EXTENSIONS: {
    ALLOWED_DOCUMENT_EXTENSIONS: [
      'pdf', 'png', 'doc', 'docx', 'jpg', 'jpeg', 'csv', 'xls', 'xlsx', 'ppt', 'pptx'
    ],
    ALLOWED_DOCUMENT_SIZE_MBS: '10'
  },
  OCR_DOCUMENT_EXTENSIONS: {
    ALLOWED_DOCUMENT_EXTENSIONS: [
      'pdf', 'png', 'jpg', 'jpeg'
    ],
    ALLOWED_DOCUMENT_SIZE_MBS: '10'
  },
  DOCUMENT_EXTENSIONS_FOR_FI: {
    ALLOWED_DOCUMENT_EXTENSIONS: [
      'pdf', 'png', 'doc', 'docx', 'jpg', 'jpeg', 'csv', 'xls', 'xlsx', 'ppt', 'pptx'
    ],
    ALLOWED_DOCUMENT_SIZE_MBS: '10'
  },
  UPLOAD_AGREEMENT_DOCUMENT_TYPES: {
    UPLOAD_DOCUMENT_EXTENSIONS: {
      ALLOWED_DOCUMENT_EXTENSIONS: ['pdf'],
      ALLOWED_DOCUMENT_SIZE_MBS: 5 // MBs
    },
    UPLOAD_DOCUMENT_HTML_EXTENSIONS: {
      ALLOWED_DOCUMENT_EXTENSIONS: ['html'],
      ALLOWED_DOCUMENT_SIZE_MBS: 5 // MBs
    }
  },
  BULK_UPLOAD_FI_DATA_DOCUMENT_TYPES: {
    ALLOWED_DOCUMENT_EXTENSIONS: [
      'csv', 'xlsx'
    ],
    ALLOWED_DOCUMENT_SIZE_MBS: '10'
  },
  DOCUMENT_TYPES_KEY_NAME: {
    CREDIT_LIMIT_ASSESSMENT_DATA_SELLER_KEY: `credit_limit_assessment_data_seller`,
    CREDIT_LIMIT_ASSESSMENT_DATA_BUYER_KEY: `credit_limit_assessment_data_buyer`,
    CREDIT_LIMIT_ASSESSMENT_DATA_TERMSHEET_KEY: `termSheetTermsDocument`
  },
  REQURIED_DOCUMENT_FOR_CREDIT_LIMIT: {
    DOCUMENT_CODES_NAMES: {
      ACC: `Application and Client Agreement`,
      AFAR: `Audited Financials + Annual Report (past 2 years)`,
      AP: `Address Proof`,
      ARR: `Aging report (Receivables/Payables)`,
      BALC: `Bank Authorization Letter confirming Authorized Signatories`,
      BACC: `Application and Agreement`,
      BGOC: `Group organization chart`,
      BCSC: `Ownership structure chart (all shareholders and UBOs owning or controlling 25% or more)`,
      POR: `Proof of regulation, if regulated`,
      BDOS: `Details of shareholders and UBOs owning or controlling 25% or more - Passport copy, address proof`,
      BPOA: `Proof of authority (POA or Board resolution)`,
      COI: `Certificate of incorporation, if unregulated`,
      BMAA: `Memorandum & Articles of association`,
      BPOL: `Proof of listing, if listed`,
      BROD: `Register of Directors`,
      BAFAR: `Audited financials + Annual Report (past 2 years)`,
      BIAML: `Information on AML risk profiling methodology`,
      BPGB: `Proof entity is government body or non-commercial government entity (if relevant)`,
      BPRD: `Passports of registered directors (board members)`,
      BCWFC: `Completed Wolfsberg FCCQ`,
      BIAS: `Identity of authorised signatory (passport copy)`,
      BVTL: `Valid Trade License or Certificate of Incumbency`,
      BROS: `Register of shareholders - Name, address, corporate information, how many layers`,
      CAF: `Company AML framework`,
      BAP: `Address proof`,
      BC: `Background Checks`,
      BS: `Bank Statement (last 6 months)`,
      CC: `Client Communication (if any)`,
      CCDD: `Customer Risk assessment & CDD Checklist`,
      CDDI: `Customer Due Diligence Information`,
      CI: `Certificate of Incorporation`,
      CELM: `Company Employee List (MoL List)`,
      CURV: `Certified UAE Residency Visa copy`,
      CSC: `Ownership Structure Chart (all Shareholders and UBOs owning or controlling 25% or more)`,
      DKYC: `Directors' KYC documents`,
      DOS: `Details of Shareholders and UBOs owning or controlling 25% or more (Passport copy, Address Proof)`,
      ECR: `Credit Bureau Report for Borrowing Company`,
      EI: `Certified Emirates ID (both sides)`,
      GOC: `Group Organization Chart`,
      IAS: `Identity of Authorised Signatory (Passport copy)`,
      INF: `Information on record of Nature of Business, Countries where Business is carried out`,
      LF: `Loan Facility letters for all existing Financial Facilities`,
      MAA: `Memorandum & Articles of Association`,
      ODD: `Ongoing Due Diligence`,
      PGB: `Proof that entity is Government Body or Non-Commercial Government entity (if relevant)`,
      POA: `Proof of Authority (POA or Board Resolution)`,
      POL: `Proof of Listing (if listed)`,
      PRD: `Passports of Registered Directors`,
      RA: `Residential Address`,
      RGC: `Registration Certificate`,
      ROD: `Register of Directors`,
      ROS: `Register of Shareholders`,
      SCLO: `Self-certified letter (for outstanding liabilities)`,
      SL: `Client-wise Sales Ledger`,
      SS: `Sector specialization`,
      TC: `Tenancy Contract`,
      TRFSE: `Tax Return Form (Sales and Expenses)`,
      VTL: `Valid Trade License or Certificate of Incumbency`,
      YTDFS: `YTD Financial Statement`,
      RPIPD: `3 Recently paid Invoices per Debtor (with Bank Statement evidence)`,
      RPIPS: `3 Recently paid Invoices per Supplier (with Bank Statement evidence)`,
      SLIST: `Top 5 Suppliers list with sales amount`,
      CBR: `Credit Bureau Report of they Key Shareholders covering >50% of the shareholding`
    },
    DOCUMENT_CATEGORY_FOR_CLIENT: {
      AFAR: `KYC`,
      AP: `KYC`,
      ARR: `OPTIONAL`,
      BS: `OPTIONAL`,
      EI: `OPTIONAL`,
      GOC: `KYC`,
    },
  },

  // change below key mappings once you get from mawani.
  REQURIED_DOCUMENT_FOR_TERM_SHEET: {
    DOCUMENT_CODES_NAMES: {}
  },

  FINANCE_DEPARTMENT_TYPES: {
    OPERATIONS: `OM`,
    EXECUTIVE: `SEO`,
    COMPLIANCE: `CO`
  },

  /* tracks a users progress through the use of the site, from first login to veteran user.*/
  milestones: {
    login: 'first_login',
    first3Logins: 'first_3_logins',
    first7Logins: 'first_7_logins',
    first15Logins: 'first_15_logins',
    first50Logins: 'first_50_logins',
    first150Logins: 'first_150_logins',
    acceptsTermsAndConditions: 'accept_terms',
    requestCreditLimit: 'request_credit_limit',
    receivesCreditLimit: 'receives_credit_limit',
    startsApplication: 'starts_application',
    submitsApplication: 'submits_application',
    acceptApplicationTerms: 'accept_application_terms',
    repaidLoan: 'repaidLoan',
  },

  urls: {
    // old stuff from CargoFlow
    register: 'admin/register',
    invite_users: 'admin/inviteUsers',
    remove_user: 'admin/users/:userCode/remove',
    get_user: 'admin/users',
    edit_user: 'admin/users/:userCode',
    change_password: 'admin/users/:userCode/password',
    verify_email: 'admin/verifyEmail/:verificationCode',

    shared_data: 'staticData', // GET

    // login endpoints
    login: 'login', // POST // Username: demouser and password: demo123
    loginWithToken: 'dtWelcome',
    logout: 'logout', // POST
    verify_captcha: 'verifyCaptcha',
    switch_orgaisation: 'switch-organisation', //POST

    // navigation config endpoint — BE filters menus based on the caller's session.
    // platform values: 'lending' | 'arranging' | 'scf' | 'bhs' | 'accounting'
    nav_config: 'config/route-config',

    // save endpoints
    save_finance: 'trade-finance/save', // POST
    save_finance_by_id: 'trade-finance/:id/save', // PUT
    save_logistics_finance: 'logistics-finance/save', // POST
    save_logistics_finance_by_id: 'logistics-finance/:id/save', // PUT

    // submit endpoints
    submit_finance: 'trade-finance/submit', // POST
    submit_finance_by_id: 'trade-finance/:id/submit', // PUT
    submit_logistics_finance: 'logistics-finance/submit', // POST
    submit_logistics_finance_by_id: 'logistics-finance/:id/submit', // PUT

    get_finance: 'logistics-finances', // GET
    get_lending_finance: 'lending/logistics-finances', // GET
    get_trade_finance: 'trade-finances?_limit=20&_page=', // GET
    get_finance_by_id: 'trade-finance/:id', // GET
    get_companies: 'organisations?verified=true', // GET
    get_all_transaction: 'transactions?_limit=20&_page=', // GET
    get_trade_transactions: 'trade-finance/transactions?_limit=20&_page=',
    get_logistics_transactions_lending: 'lending/logistics-finances/transactions',
    get_logistics_transactions: 'logistics-finance/transactions',
    // get_trade_upcoming_transactions: 'trade-finance/upcoming-transactions?_limit=20&_page=',
    // get_all_uocoming_transaction: 'upcoming-transactions?_limit=20&_page=',
    get_logistics_upcoming_transactions_lending: 'lending/logistics-finances/upcoming-transactions?_limit=20&product_category=ProductCategory&product_type=ProductType&_page=',
    get_logistics_upcoming_transactions: 'logistics-finance/upcoming-transactions?_limit=20&product_category=ProductCategory&product_type=ProductType&_page=',
    get_overdue_transactions_lending: 'lending/overdue-transactions?_limit=20&product_category=ProductCategory&product_type=ProductType&_page=',
    get_transaction: 'finances/:financeId/transactions/:transactionId', // GET
    notifications_read: 'notifications/:id/status', // PUT
    lendingNotificationRead: 'notifications/:id/status-lending',
    notifications: 'notifications', // GET
    lendingNotifications: 'notifications-lending',
    // trade_credit_limit: 'trade-finance/credit-summary/:orgId', // GET
    arrangingCreditSummary: 'logistics-finance/credit-summary', // GET
    lendingCreditSummary: 'lending/finance-application/credit-summary',
    get_settings: '',
    save_settings: '',
    upload_document: '',
    set_credit_limit: 'credit-limit/',
    docusign: 'docusign-link',
    // get_upcoming_transaction: 'upcoming-transactions?_limit=60&_page=1',
    remarks: 'remarks',
    getDocuments: 'mawani-documents',
    getCompanyDocuments: 'organisation-documents',
    getLendingCompanyDocuments: 'lending/organisation-documents',
    downloadDocuments: 'download-mawani-document/:docid',
    contactUs: 'contact-us',
    contactUsLoggedIn: 'contact-us-logged-in',
    application_status: 'application-statuses',
    all_bank_organization: 'get-bcos/:bankId',
    store_document_acceptance_version: 'user-terms/accept',
    fiOnBoardingApi: 'collect-finance-inst-data',
    getRequestedCreditLimit: 'get-credit-limit-data',
    getCreditLimitDetails: 'get-credit-limit-details',
    getSingleRequestedCreditLimit: 'get-credit-limit-data/:id',
    getSingleCreditLimitDataPublicApi: 'get-credit-limit-data-public?id=CreditLimitId&userToken=UserToken&counter_party_id=',
    setCreditLimitRequest: 'set-credit-limit/:fiId',
    setCreditFacilityRequest: 'set-credit-facility/:fiId',
    updateCreditFacilityRequest: 'update-credit-facility/:fiId',
    updateCreditFacilityRequestByCA: 'create-cf-update-request/:fiId',
    getNotAppliedRequestedCreditLimit: 'get-not-applied-finance-institutions',
    applyCreditLimit: 'apply-credit-limit',
    renewCreditLimit: 'renew-credit-limit',
    termsAcceptanceApi: 'accept-credit-limit-terms/:id',
    getFiDetailById: 'get-finance-inst-data/:finInstId',
    downloadDocForCreditLimit: 'credit-limit/:id/document/:docId',
    downloadDocForLendingCreditLimit: 'credit-limit-lending/:id/document/:docId',
    downloadDocForLendingFinApp: 'logistics-finance-lending/:id/document/:docId',
    downloadDocForCreditLimitPublicApi: 'credit-limit/document-public?userToken=:UserToken&id=:ID&docId=',
    getFiBuyerData: 'get-credit-limit-data-apply-page?product_category=ProductCategory&product_type=ProductType',
    getUserTermsAccept: 'user-terms/:orgId',
    downloadTermsAccept: 'user-terms/document?version=Version&documentType=DoumentType&documentFormat=format',
    uploadTermsAccept: 'user-terms/document',
    reSendTermsAcceptMail: 'user-terms/sendmail',
    validateToken: 'validate-token',
    acceptTermsViaExternalLink: 'client-agreement/accept',
    publicDownloadApi: 'user-terms/download-document?email=Email&userToken=User&version=Version&documentType=DocumentType&documentFormat=format',
    publicDocumentApi: 'user-terms/download-document?documentType=docType&documentFormat=format',
    transactionMonitoring: 'approve-transaction/:transactionId',
    fiTermsValidation: 'fiterm-validation/:transactionId',
    waiveOffOverdue: 'lending/logistics-finance/waive-off-overdue-fee',
    validateAccessToken: 'validate-access-token',
    refreshTokenUrl: 'login-with-refresh-token',
    creditLimitTermsAcceptPublicApi: 'credit-limit-terms-acceptance-page?userToken=',
    docusignPublicLink: 'docusign-link-public',
    docusignRecipientDetailsPublicApi: 'docusign-recipient-details-public',
    docusignDocumentDownloadPublicApi: 'docusign-documents-public',
    acceptTermsPublicApi: 'accept-credit-limit-terms-public',
    externalClientEmailApi: 'send-credit-limit-terms-mail',
    externalClientFinanceAppEmailApi: 'send-finance-terms-mail',
    getListOfCounterParty: 'onboarded-counter-party-organisations/:organisationId',
    history: 'history',
    historyFilterValues: 'filter-values',
    historyForLending: 'lending/history',
    getSingleFinanceUsingPublicApi: 'logistics-finance/finance-terms-public?id=financeId&userToken=',
    acceptFinancePublicApi: 'logistics-finance/accept-terms-public',
    docusignRecipientDetailsPublicApiFinance: 'docusign-recipient-details-public',
    docusignDocumentDownloadPublicApiFinance: 'docusign-documents-public',
    downloadBuyerDocPublicApi: 'logistics-finance/document-public?id=financeId&docId=DocId&userToken=',
    updateInTransitFinanceData: 'logistics-finance/:id/update-finance-data-fi',
    updateInTransitLendingFinData: 'lending/logistics-finance/:id/update-finance-data',
    fiDisbursalDateCalculationApi: 'logistics-finance/fi-assessment-calculation',
    lendingFICalculationApi: 'lending/fi-assessment-calculation',
    fiAssessCreditFacility: 'fi-assess-credit-facility/:fiId',
    bankAssessmentAPI: 'logistics-finance/:id/bank-assessment',
    lendingBankAssessmentAPI: 'lending/bank-assessment/:id',
    applyFinanceCalcApi: 'logistics-finance/get-apply-finance-calculation',
    transactionCalcApi: 'logistics-finance/transaction-page-calculation',
    arrangingCalcApi: 'logistics-finance/arranging-page-calculation',
    transactionEvaluateApi: 'lending/logistics-finance/evaluate-transaction-event',
    getTransactionDetails: 'logistics-finances/transaction',
    settlementAdjustment: 'lending/logistics-finance/settlement-adujestment-waiver',
    recalcRiskRatingApi: 'update-cra-summary-by-orgid',
    complianceScreening: 'company-compliance-screening/',
    getScreeningData: 'get-compliance-screening-data/',
    retriggerOcr: 'registration-ocr-data',
    trnxComplianceScreening: 'transaction-compliance-screening/',
    updateSwitchTenantOptionApi: 'organisations/tenant-switch',
    updateDpwfsLendingOptionApi: 'organisations/borrow-setting',
    riskRatingConfiguration: 'risk-current-configuration',
    shipmentStatus: 'shipment-status',
    faqSharepointVideoUrl: 'https://cargoesfinancestaging.blob.core.windows.net/faq-videos/',
    userManualImageUrl: 'https://cargoesfinancestaging.blob.core.windows.net/static-images/ImageFolderPath',
    getLatestReleaseNotes: 'support/release-notes',
    getMonthwiseReleaseNotes: 'support/release-notes/:tenure',
    saveReleaseNotes: 'support/release-notes/save',
    moreFiltersUrl: 'filter-values',
    downloadCreditLimitReport: 'download-credit-limit',
    stopReminderEmailNotifications: 'stop-reminder-email-notifications/',
    downloadFinanceReport: 'download-finance',
    downloadCompletedTrnxReport: 'download-completed-transaction',
    downloadUpcomingTrnxReport: 'download-upcoming-transaction',
    downloadOverdueTrxnReport: 'download-overdue-transaction',
    applicationBulkUpdateUrl: 'logistics-finance/bulk-bank-assessment',
    transactionBulkUpdateUrl: 'logistics-finance/bulk-transaction',
    onboardCaymanOrganisation: 'organisation/mawani/create',
    updateCaymanEntity: 'organisation/mawani/update',
    getCaymanEntityDetails: 'organisation/mawani/:mawaniRefId',
    getReferenceValues: 'company-kyc-approval/reference-values?referenceTypeCodes=ReferenceCode&tenantCode=TenantCode',
    getReferenceValuesCF: 'company-kyc-approval/reference-values',
    getCompanyRegDetails: 'get-company-reg-details',
    getCompanyRegDocuments: 'get-company-reg-documents',
    generateOTP: 'generate-otp',
    validateOTP: 'validate-otp',
    registerUser: 'register-user',
    switchTenantUrl: 'organisation/mawani/create-different-tenant-org',
    countryCodes: 'country-codes',
    panjivaCompaniesUrl: 'panjiva-company-names',
    getMawaniCompanyInDraftUrl: 'get-mawani-companies-draft-state',
    getFiBuyerDataForClient: 'get-credit-limit-data-apply-page-admin?product_category=ProductCategory&product_type=ProductType&client_org_id=ClientOrgId',
    getFinanceClientsData: 'apply-finance-clients?product_category=ProductCategory&product_type=ProductType',
    getInvoiceReportUrl: 'send-email-dpwfs-regenerated-commission-invoicing',
    ssoSignupProceed: 'sso-signup-proceed',
    creditFacilityTradingPartnerUrl: 'latest-credit-facility-trading-partners/',
    pendingTasksUrl: 'pending-tasks',
    lendingPendingTaskUrl: 'pending-tasks-lending',
    kycDetailsUrl: 'get-kyc-details',
    kycFilledDetailsUrl: 'get-client-kyc-details-for-lenderbank-ui',
    lendingRemarks: 'lending-remarks',
    store_document_acceptance_version_lending: 'user-terms-for-dfsa/accept',
    ocrInvoicesAnalysis: 'finance-ocr-data',
    searchCompanyList: 'search-company',
    getCompanyKycDetails: 'company-data',
    getCompanyKycDocuments: 'company-documents',
    // settlementCalcApi: 'logistics-finances/settlement-calculation/',
    creditLimitFinalSignReview: 'lending/credit-limit-sign-review/',
    creditLimitUpdateSignReview: 'lending/credit-limit-update-sign-review/',
    publishSectionOmApi: 'lending/credit-limit-sign-review/:id',
    publishSectionOmUpdateApi: 'lending/credit-limit-update-sign-review/:id',
    salesAgentDataApi: 'get-sales-agent-data/',
    addSalesAgentDataApi: 'add-sales-agent-data/',
    updateDocusignRecipient: 'docusign-update-recipient/:id',
    publishSectionApi: 'lending/set-credit-limit-section/:id',
    lendingCreditBorrowerFacilitiesAPI: 'lending/get-user-credit-limit-data/',
    companyKycInfoAPI: 'companies-kyc-info',
    compKycFiltersAPI: 'companies-kyc-info/filters',
    uploadTemplateDocApi: 'lending/submit-loan-document-mapping',
    getTemplateDocApi: 'lending/get-loan-document',
    loanDocMappingValues: 'lending/get-loan-document-mapping',
    kycDocumentInfoAPI: 'companies-kyc-documents',
    kycDocumentFilterAPI: 'companies-kyc-documents/filters',
    arrangingPlatformClientRemarksAPI: 'lending/get-client-remarks-from-arranging-platform',
    uploadedLoanDocInfo: 'lending/get-all-loan-document-info',
    deleteLoanDocTemplate: 'lending/delete-loan-document/:id',
    getLoanDocTemplate: 'lending/get-loan-document/:id',
    arrangingDocDownloadCreditLimit: 'organisation-documents/:id/document/:docId',
    lendingDocDownloadCreditLimit: 'lending/organisation-documents/:id/document/:docId',
    cargoesBLDocAPI: 'ehbl/document',
    cargoesBLCustodyAPI: 'ehbl/surrender-custody-of-hbl',
    cargoesBLCustodianInfoAPI: 'ehbl/ownership/',  // gitleaks:allow
    cargoesBLDataAPI: 'ehbl/',
    creditPolicyGetAPI: 'lending/get-credit-policy',
    creditPolicyPostAPI: 'lending/set-credit-policy/',
    combinedFinanceRateAPI: 'lending/combined-finance-rate/',
    convertDocxFileToPdf: 'lending/convert-document',
    settlementDueTrnxsAPI: 'lending/upcoming-transactions',
    flaggedOrgCaApprovalAPI: 'lending/logistics-finance/:id/transaction-for-defaulter-disbursal',
    getFlagsAPI: 'flagValues',
    createFlagAPI: 'flagValues',
    getKYCApprovalCompanies: 'company-kyc-approval/companies',
    getLendingKYCApprovalCompanies: 'lending/companies-kyc-info',
    getKYCApprovalInternalComments: 'company-kyc-approval/comments',
    getKYCApprovalDocumentTypes: 'company-kyc-approval/company-document-types',
    getKYCStatusWorkflow: 'company-kyc-approval/status-workflow',
    getAllCompanyServices: 'company-kyc-approval/company-services',
    companyServicesStatusChange: 'company-kyc-approval/company-services',
    companySuspensionAPI: 'company-kyc-approval/:companyReference/suspend/:isSuspend',
    postKYCApproveOrRejectStatus: 'company-kyc-approval/execute-action',
    postKYCOnHoldStatus: 'company-kyc-approval/hold',
    getKYCApprovalHistory: 'company-kyc-approval/history',
    getKYCApprovalAuditHistory: 'company-kyc-approval/audit',
    getRegisteredServices: 'company-kyc-approval/registered-services',
    getHistoryQuestions: 'company-kyc-approval/history-questions',
    getKYCCodeIssuers: 'company-kyc-approval/code-issuers',
    getTransferOwnershipUser: 'company-kyc-approval/transfer-ownership-user',
    postTransferOwnership: 'company-kyc-approval/transfer-ownership',
    postPreventAutomaticOnHold: 'company-kyc-approval/:companyReference/prevent-automatic-on-hold/:preventOnHold',
    inviteUser: 'company-kyc-approval/invite-user',
    cfInfoForApplicantAPI: 'get-cf-info-for-applicant/:fi_id/applicant/',
    cfEligibilityQuestionsAPI: 'get-cf-eligibility-questions/',
    checkCfEligibilityForApplicant: 'check-eligibility-for-applicant/:fi_id/applicant/',
    holidayCalendar: 'holidayCalendar',
    holidayCalendarConfig: 'holidayCalendar/config',
    holidayCalendarWeekendConvention: 'holidayCalendar/weekendConvention',
    holidayCalendarAuditLog: 'holidayCalendar/auditLog',
    holidayCalendarValidateRange: 'holidayCalendar/validate/range',
    holidayCalendarValidate: 'holidayCalendar/validate',
    checklistCfGatekeeper: 'checklist/cf/',
    checklistApplicationGatekeeper: 'checklist/application/',
    checklistCfList: 'checklist/cf/',
    checklistApplicationList: 'checklist/application/',
    autoSaveAPI: 'auto-save',
    getAutoSaveAPI: 'get-auto-save',
    submitCreditFacilityAPI: 'submit-credit-facility',
    uploadDocumentsAPI: 'documents',
    bhsUploadDocumentsAPI: 'bhs/documents',
    uploadDocumentsPublicAPI: 'documents-public',
    createCreditFacility: 'create-credit-facility/:fi_id/applicant/',
    getCpInfoForApplicantAPI: 'get-cp-info-for-applicant/:applicant_id',
    saveNewCounterPartiesLendingAPI: 'lending/add-counter-party/:owner_id',
    saveLendingExceptionDraftAPI: 'lending/save-exception',
    acceptCFTermSheetPatchAPI: 'accept-credit-facility-term-sheet/',
    downloadDocumentsAPI: 'documents',
    BHSDownloadDocumentsAPIurl: 'api/documents/download',
    bhsDownloadDocumentsAPI: 'bhs/documents',
    downloadDocumentsLendingAPI: 'lending/documents',
    acceptCreditFacilityTermsAPI: 'accept-credit-facility-terms',
    cfAcceptBuyerTermsPublicAPI: 'accept-credit-facility-terms-public',
    updateCreditFacilityAPI: 'upgrade-credit-limit/',
    cfAgreementUpdateApi: 'lending/cf-aggrement-update/:id',
    renewCFApi: 'renew-credit-facility/',
    submitPendingCfDocuments: 'submit-pending-credit-facility-details/',
    removeClientNewCF: 'credit-facility/', // POST :id/remove-client
    removeClientUpdateRenew: 'credit-facility/', // POST :id/request/:requestId/remove-client
    sendImporterAcceptanceMailNewCF: 'credit-facility/', // POST :id/send-importer-acceptance-mail
    sendImporterAcceptanceMailUpdateCF: 'credit-facility/', // POST :id/request/:requestId/send-importer-acceptance-mail
    getSCFPrograms: 'scf-program/programs',
    getSCFTransactionHistory: 'scf/transactions',
    postScfInvoices: 'scf-finance/validation-calculation-file/apply',
    postScfApplication: 'scf-finance/apply',
    getSCFFIList: 'scf-application/fiList',
    getBuyerList: 'scf-application/buyersList',
    createSCFProgram: 'scf-program',
    scfFinanceInvoiceDetailsApi: 'scf/finance-invoices',
    scfDownloadProgramDetailsSheet: 'scf-application/generate-program-details-sheet',
    scfUpdateFinanceStatus: 'scf/finance-status',
    scfGetFinanceDataApi: 'scf-finance',
    manualTriggerAdvices: 'lending/manual-trigger-for-advices',
    regulatoryReportsAPI: 'lending/regulatory-report',
    scfRunAccuity: 'scf-transaction-compliance-screening',
    scfGetAccuityData: 'scf-transaction-compliance-screening-data',
    scfUpdateAccuityStatus: 'scf/update-transaction-monitoring-status',
    scfDownloadFinanceData: 'scf-finance/download-finance-data-report',
    scfDownloadProgramData: 'scf-program/download-program-data-report',
    scfMakerCheckerPrivilege: 'scf/has-checker-privilege/:financeId',
    scfNotifications: 'scf-notifications',
    feedback: 'feedback',
    insuranceTable: 'lending/insurances',
    createInsurance: 'lending/insurance',
    getInsuranceDetails: 'lending/insurance',
    insuranceCompanies: 'insurance/companies',
    insurancePolicies: 'insurance/policies',
    insuranceInsurerList: 'insurance/insurers',
    insuranceAttachments: 'insurance/attachments',
    insuranceBindings: 'history?category=INSURANCE_BINDING&',
    insuranceEmailReport: 'insurance/reports/generate',
    generateTransactionAdvicesApi: 'lending/generate-transaction-advices',
    lendingCfExceptionCalc: 'lending/calculate-exception-irr',
    clChargesForFinance: 'get-credit-limit-charges-finance-page',
    getAuthorisedSignatoryDetails: 'auth-signatories',
    getAecbTable: 'lending/get-aecb-table-data',
    getAecbDetails: 'lending/get-aecb-file-data',
    submitAecbDetails: 'lending/submit-aecb-data',
    inputFieldUrl: 'fields',
    generateTermsUrl: 'generate-terms',
    getTermSheetTableData: 'lending/term-sheet',
    termSheetIrrCheckUrl: 'term-sheet-irr/:termsId',
    generateTermSheetUrl: 'generate-term-sheet/:termsId',
    submitTermSheetUrl: 'lending/term-sheet-action/:termsId',
    createGenerateTerms: 'lending/create-generate-terms',
    companyKycTrimmedData: 'lending/organisation/mawani/:mawaniRefId?trimmedData=true',
    getAllRaisedCreditFacility: 'get-all-raised-credit-facility',
    exposureControl: 'lending/exposure-control-terms',
    existingLendingCFs: 'lending/creditfacility-list',
    lists: 'list',
    updateExposures: 'lending/exposure',
    bankReceiptsApi: 'lending/finance/:financeId/receipts?receiptCategory=RECEIPT_CAT',
    getBankReferencesApi: 'lending/bank-references',
    aecbDropDownValues: 'lending/aecb-dropdowns',
    getFacilityFeePayment: 'lending/facility-fee-payment',
    getFacilityFeeDetails: 'lending/cf-facility-fee-payment',
    getGroupDetails: 'get-group-details',
    downloadCFReviewReport: 'lending/download-cf-review-report',
    getCounterPartyByFacilityId: 'lending/getCounterPartyByFacilityId',
    bhsFacilityDetails: 'bhs/facility-details',
    bhsFinanceDetails: 'bhs/finance-details',
    bhsSubmitFinanceApi: 'bhs/finance-details',
    bhsFinanceReviewApi: 'bhs/finance-review',
    getFacilityList: 'bhs/facility-list',
    bhsTransactionApi: 'bhs/transaction',
    bhsTransactionReviewApi: 'bhs/transaction-review',
    sofrRatesUrl: 'sofr-rates',
    updateRequestTermDetails: 'lending/inventory-details/:financeId',
    cpComplianceScreeningApi: 'lending/counter-party-compliance-screening',
    cpRiskRatingApi: 'lending/risk-rating/counterparty',
    getAccountCategorisationData: 'lending/get-client-category-data',
    getClientCategorisationHistory: 'lending/get-client-category-history',
    getLinkedUnlinkedData: 'lending/financial-assessment-org-mapping',
    getPortfolioTabsData: 'lending/portfolio-reviews',
    getPortfolioSessionData: 'lending/portfolio-reviews/session', //:sessionId
    downloadPortfolioReviews: 'download-portfolio-reviews',
    downloadPortfolioReviewsSessions: 'download-portfolio-review-sessions',
    getDepartmentOwners: 'get-department-owners',
    getFinanceAssessmentData: 'lending/financial-assessment',
    getApprovedCompanies: 'organisations',
    updateClientCategory: 'lending/update-client-category',
    getOngoingMonitoringDataApi: 'lending/company-kyc-approval/ongoing-monitoring/:mawaniRefId',
    getRiskRatingDataApi: 'company-kyc-approval/risk-assessment/:mawaniOrgRefId',
    getTemplateData: 'templates/:fileType',
    getKYCDocumentHistory: 'company-kyc-approval/document-approval-history',
    getKYCDocumentsSummary: 'company-kyc-approval/document-approval-history-summary',
    getSCFDisursementReport: 'get-disbursement-report-data',
    getSCFMaturityReport: 'get-maturity-report-data',
    getSCFCommissionReport: 'get-commission-report-data',
    emailSCFReports: 'email-scf-reports',
    rejectApplication: 'lending/reject-application/',
    getLoanDocVersionHistory: 'get-loan-document-versions/',
    getRiskObligors: 'get-risk-obligors/',
    ongoingMonitoringTableApi: 'lending/companies-kyc-info/get-ongoing-monitoring',
    ongoingMonitoringEmailApi: 'lending/companies-kyc-info/download-ongoing-monitoring',
    getFinanceAssessmentDetails: 'financial-assessment',
    triggerDownloadRatiosApi: 'financial-assessment-download',
    getFacilityFeeInvoiceDetails: 'get-invoice-details',
    getDepartmentOwnerDetails: 'get-department-owners',
    getArTableDataDetails: 'credit-facility', //credit-facility/:id/ars
    emailIndividualFacilityFeeDetails: 'download-facility-fee',
    emailFacilityFeeReport: 'aff-individual-details',
    createAffInvoice: 'create-aff-invoice',
    updateAffInvoice: 'update-aff-invoice',
    settleAffInvoice: 'settle-aff-invoice',
    getArDetails: 'get-ar-details',
    getAllSponsors: 'get-all-sponsors',
    getAllARInvoices: 'get-all-ar-invoice',
    getAllARCreditNotes: 'get-all-ar-credit-notes',
    getCreditNoteDetails: 'credit-note',
    createCreditNote: 'create-credit-note',
    updateCreditNote: 'update-credit-note',
    evaluateAFFCalculationApi: 'evaluate-aff-transaction',
    exportCustomInterestReportApi: 'export-interest-schedule-report',
    getArChargesApi: 'fetch-ar-details',
    getTransactionPendingAmount: 'get-application-outstanding-amount',
    getTransactionSummary: 'transaction-summary',
    transactionSummaryExport: 'transaction-summary/export',
    getApplicantDetailsAppication: 'get-applicant-info/',
    getMasterPoList: 'logistics-finance/master-instrument-list',
    getPreshipmentFinanceAmountApi: 'logistics-finance/preshipment-finance-amount',
    retryButtonClicked: 'retry-credit-note',
    saveCounterParty: 'save-counter-party',
    downloadCounterPartyReportApi: 'download-counter-party-report',
    documentVersionsApi: 'document/version',
    fetchAllDMSDocumentsApi: 'all-documents',
    uploadDMSDocumentAPI: 'document',
    updateFacilityDocument: 'document/update',
    uploadFacilityDocument: 'document/submit',
    newCommonCommentsApi: 'comments',
    savePlaceholderMapping: 'lending/save-placeholder-mapping',
    getPlaceholderMapping: 'lending/placeholder-mapping',
    submitChecklist: 'checklist/template',
    getStages: 'checklist/stages',
    getChecklists: 'checklist/templates',
    getChecklistTemplateMetadata: 'checklist/template-metadata',
    checklistInstanceTask: 'checklist/instance/',
    saveChecklist: 'checklist/template/draft',
    updateChecklist: 'checklist/template',
    checklistFilters: 'checklist/filter-values',
    createChecklistInstance: 'lending/checklist/instance/create-from-entity',
    fetchMawaniDocumentApi: 'mawani', // mawani/companies/COM_REF/documents/DOC_REF,
    approverGroups: 'workflow/client-types',
    askList: 'api/v1/ask',
    askMyQueue: 'api/v1/ask/my-queue',
    askClaim: 'api/v1/ask',
    askTransition: 'api/v1/ask',
    askAssist: 'api/v1/ask',
    askDropdowns: 'api/v1/ask/dropdowns',
    askUsers: 'api/v1/ask/users',
    askFilterValues: 'api/v1/ask/filter-values',
    askMyQueueFilterValues: 'api/v1/ask/my-queue/filter-values',
    askAdminFilterValues: 'api/v1/ask/admin/filter-values',
    askCapacityFilterValues: 'api/v1/ask/capacity/filter-values',
    askCandidates: 'api/v1/ask', // + /{id}/reassignment-candidates
    askAssign: 'api/v1/ask', // + /{id}/assign
    askReassign: 'api/v1/ask', // + /{id}/reassign
    askCapacityOverview: 'api/v1/ask/capacity/overview', // ?memberName=&availability=&role= (Team Overview list)
    askCapacityTeamReport: 'api/v1/ask/capacity/team-report', // ?memberName=&availability=&role= (Team Overview export)
    askCapacityUser: 'api/v1/ask/capacity', // + /{userId} (drawer capacity)
    askMemberStats: 'api/v1/ask/member', // + /{userId}/stats?dateFrom&dateTo, or /{userId}/report?dateFrom&dateTo (Member Detail export)
    askAdminQueue: 'api/v1/ask/admin/queue', // ?taskOwnerUserId=&status=&page=&limit=&sortBy=&sortDirection=
    uploadBHSSDocumentAPI: 'api/documents/upload',
  },
  storage: {
    currentUser: 'current-user',
    currentTenant: 'current-tenant',
    switchTenant: 'switch-tenant',
    companyName: 'user-signup-company',
    annualTransaction: 'user-annual-transaction',
    registerCompanyAccessed: 'register-company-clicked',
    onboardingClientCountry: 'onboarding-client-country',
    lendingEntityExists: 'lending-entity-exists',
    addCompClientOrFI: 'add-comp-client-or-fi',
    clientOrFI: 'client-or-fi',
    gaConnectorInfo: 'ga_connector_info',
    poFilters: 'po-filters',
    containerFilters: 'container-filters',
    oceanShipmentFilters: 'shipment-filters',
    productFilters: 'product-filters',
    locationFilters: 'location-filters',
    tpFilters: 'tp-filters',
    InlandShipmentFilters: 'inland-shipment-filters',
    ShipmentFilters: 'shipments-filters',
    applicationSettings: 'application-settings',
    financeType: 'finance-type',
    clientOrFiAgreementsAccepted: 'client-or-fi-agreement-accepted',
    termsAndConditionsAccepted: 'terms-conditions-accepted',
    returnToHomeDueToFailure: 'return-to-home-due-to-failure',
    creditLimitNotification: 'credit-limit-notification',
    FinancialInstitution: 'FinancialInstitution',
    termsAndConditionsAcceptedArranging: 'terms-conditions-accepted-arranging-platform',
    kycRenewalFilters: 'kyc-renewal-filters',
    ongoingMonitoringFilters: 'ongoing-monitoring-filters',
    askManagementFilters: 'ask-management-filters',
    applicationFilters: 'application-filters',
    creditFacilityFilters: 'credit-facility-filters',
    kycDocRenewalFilters: 'kyc-doc-renewal-filters',
    getLatestReleaseNotes: 'latest-release-notes',
    releaseNotesNotificationPopup: 'release-notes-notification-popup',
    scfPlatform: 'scf-platform',
    routeConfig: 'route-config',
    routeConfigPlatform: 'route-config-platform',
    accountingReconciliationModule: 'enable-accounting-reconciliation',
    bhsModule: 'bhs-platform',
    productCombination: 'product-combination',
    clientClassificationNotice: 'client-classification-notice',
    clientClassificationNoticeForFI: 'client-classification-notice-fi',
    clientClassificationNoticeForFacility: 'client-classification-notice-facility',
    pendingAction: 'pending-action',
  },
  tablePageSize: 20,
  debounceTime: 450,
  alertRemoveTimer: 1500, // 1.5 seconds to mark alerts as read
  cacheMaxAge: {
    poList: 60000, // 60 seconds
    poSuppliers: 300000, // 5 minutes
  },
  maxLoginAttemptsWithoutCaptcha: 3,
  maxLoginAttemptsBeforeLock: 5,
  recaptchaSiteKey: '6Le6bvoUAAAAAHOyATilmn5kDxR_hB7E2gKxbpSs', // gitleaks:allow
  recaptchaSiteKeyForTesting: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI', // gitleaks:allow
  recaptchaUrl: 'https://www.google.com/recaptcha/api.js?onload=grecaptchaCallback&amp;render=6Le6bvoUAAAAAHOyATilmn5kDxR_hB7E2gKxbpSs',

  apiKey: 'X-DPW-ApiKey',
  uiSetting: {
    select_All_DisplayText: 'All',
  },

  API_RESPONSE_CODES: {
    STATUS_CODES: {
      200: 'Ok',
      201: 'Created',
      400: 'Bad request',
      401: 'Unauthorized',
      403: 'Forbidden',
      404: 'Not found',
      409: 'Conflict',
      429: 'Too Many Requests',
      440: 'Login expired',
      500: 'Server error',
    },
    REASON_CODES: {
      // the first three digits are the corresponding status code; the text will be used in log
      20000: 'Success',
      20100: 'Created',
      40010: 'Invalid request data',
      40020: 'Invalid email address',
      40030: 'Bad argument error',
      40110: 'No API Key provided',
      40120: 'Invalid API Key',
      40130: 'Blocked by access_control',
      40140: 'Blacklisted IP address',
      40150: 'Missing required header',
      40160: 'Invalid value in header',
      40310: 'Client not provisioned to access route',
      40320: 'Missing Authorization header or it is invalid',
      40330: 'Incorrect username or password',
      40340: 'Username in header does match login request parameter',
      40410: 'The requested object does not exist',
      40910: 'Conflict in creation',
      42910: 'The rate of requests is over provisioned limit',
      44010: 'User token expired',
      50090: 'Internal Sever Error',
    },
  },
  USER_ROLES: {
    CREDIT_FACILITY: {
      VIEW: 'CREDIT_FACILITY_VW',
      AMEND: 'CREDIT_FACILITY_AMEND'
    },
    APPLICATION: {
      PRCS_VIEW: 'APPLICATION_PRCS_VW',
      PRCS_AMEND: 'APPLICATION_PRCS_AMEND',
      TRNX_VIEW: 'APPLICATION_TRNX_VW',
      TRNX_AMEND: 'APPLICATION_TRNX_AMEND'
    },
    SETTINGS: {
      VIEW: 'ACCESS_SETTING_VW',
      AMEND: 'ACCESS_SETTING_AMEND'
    },
    AUDIT: {
      VIEW: 'AUDIT_TRAIL_VW',
    },
    REPORTS: {
      VIEW: 'REPORTS_VW'
    },
    SCF: {
      VIEW: 'SCF_VW',
      AMEND: 'SCF_AMEND'
    },
    KYC_APPROVAL: {
      VIEW: 'KYC_APPROVAL_VW',
      PROFILE_AMEND: 'COMPANY_INFO_AMEND',
      KYC_INFO_AMEND: 'KYC_INFO_AMEND',
    },
    REGULATORY_REPORTS: {
      VIEW: 'FINANCE_REPORTS_VW',
      AMEND: 'FINANCE_REPORTS_EDIT'
    },
    AECB_FILES: {
      VIEW: 'AECB_FILE_VW',
      AMEND: 'AECB_FILE_EDIT'
    },
    INSURANCE: {
      VIEW: 'INSURANCE_VW',
      AMEND: 'INSURANCE_AMEND',
      LINK: 'INSURANCE_LINK'
    },
    ACCOUNTING_RECONCILIATION: {
      FINANCE: {
        VIEW: 'ACCOUNTING_FINANCE_VW',
        AMEND: 'ACCOUNTING_FINANCE_AMEND'
      },
      MAKER: {
        VIEW: 'ACCOUNTING_MAKER_VW',
        AMEND: 'ACCOUNTING_MAKER_AMEND'
      },
      CHECKER: {
        VIEW: 'ACCOUNTING_CHECKER_VW',
        AMEND: 'ACCOUNTING_CHECKER_AMEND'
      },
      EDIT: {
        VIEW: 'ACCOUNTING_EDIT_VW',
        AMEND: 'ACCOUNTING_EDIT_AMEND'
      }
    },
    BHS: {
      APS: {
        VIEW: 'BUYSELL_APS_VW',
        AMEND: 'BUYSELL_APS_AMEND'
      },
      APPLICATION: {
        VIEW: 'BUYSELL_APPLICATION_VW',
        AMEND: 'BUYSELL_APPLICATION_AMEND'
      }
    },
    LOAN_DOCUMENTATION: {
      VIEW: 'LOAN_DOCUMENTATION_VW',
      AMEND: 'LOAN_DOCUMENTATION_AMND',
    },
    FINANCE_ASSESSMENT: {
      VIEW: 'FINANCIAL_ASSESMENT_VW',
      AMEND: 'FINANCIAL_ASSESMENT_AMEND',
    },
    PORTFOLIO_MONITORING: {
      VIEW: 'PORTFOLIO_REVIEW_VW',
      AMEND: 'PORTFOLIO_REVIEW_AMEND',
    },
    ASK: {
      READ: 'ASK_VW',
      AMEND: 'ASK_AMEND',
      ADMIN: 'ASK_ADMIN',
    }
  },

  MAWANI_NEW_BUSINESS_SECTOR_DETAILS: {
    AUTO_DISTRIBUTOR: {
      id: 1155,
      code: "AUTO_DISTRIBUTOR",
      value: "Auto Distributor",
    },
    CONTRACTOR_INTERIOR_FIT: {
      id: 1156,
      code: "CONTRACTOR_INTERIOR_FIT",
      value: "Contractor for Interior Fit Out works"
    },
    TRADER_OF_FOOD_AND_BEVERAGES: {
      code: 'TRADER_OF_FOOD_AND_BEVERAGES',
      id: 1074,
      value: 'Trader of Food and Beverages'
    },
    MANUFACTURER_OF_PACKAGING_PRODUCTS: {
      code: 'MANUFACTURER_OF_PACKAGING_PRODUCTS',
      id: 1076,
      value: 'Manufacturer of Packaging Products'
    },
    PROC_TRADING_AGRICULTURAL_COMMODITIES: {
      code: 'PROC_TRADING_AGRICULTURAL_COMMODITIES',
      id: 1060,
      value: 'Processing and Trading of Agricultural Commodities'
    },
    TRADING_OF_CHEMICALS: {
      code: 'TRADING_OF_CHEMICALS',
      id: 1067,
      value: 'Trading of Chemicals'
    },
    MANUFACTURING_OF_ALLOYS: {
      code: 'MANUFACTURING_OF_ALLOYS',
      id: 1073,
      value: 'Manufacturing of Alloys'
    },
    EDIBLE_OIL_REFINERY_AND_PACKAGING: {
      code: 'EDIBLE_OIL_REFINERY_AND_PACKAGING',
      id: 1072,
      value: 'Edible Oil Refinery and Packaging'
    },
    MFG_DISTRIBUTOR_AGROCHEMICALS_FERTILIZERS: {
      code: 'MFG_DISTRIBUTOR_AGROCHEMICALS_FERTILIZERS',
      id: 1071,
      value: 'Manufacturer and Distributor of Agrochemicals/Fertilizers'
    },
    MANUFACTURER_OF_STEEL_PRODUCTS: {
      code: 'MANUFACTURER_OF_STEEL_PRODUCTS',
      id: 1062,
      value: 'Manufacturer of Steel Products'
    },
    FINANCIAL_SERVICES: {
      code: 'FINANCIAL_SERVICES',
      id: 152,
      value: 'Financial Services'
    },
    MFG_AND_TRADING_OF_BUILDING_MATERIALS: {
      code: 'MFG_AND_TRADING_OF_BUILDING_MATERIALS',
      id: 1139,
      value: 'Trading of Building Materials'
    },
    ASSEMBLY_TRADING_OF_LEAD_ACID_CELLSBATTERY: {
      code: 'ASSEMBLY_TRADING_OF_LEAD_ACID_CELLSBATTERY',
      id: 1064,
      value: 'Assembly & Trading of Lead Acid Cells/Battery'
    },
    PROCESSING_AND_TRADING_OF_TOBACCO: {
      code: 'PROCESSING_AND_TRADING_OF_TOBACCO',
      id: 1059,
      value: 'Processing and Trading of Tobacco'
    },
    MFG_HYGIENE_PERSONAL_CARE_PRODUCTS: {
      code: 'MFG_HYGIENE_PERSONAL_CARE_PRODUCTS',
      id: 1082,
      value: 'Manufacturer of Hygiene and Personal Care Products'
    },
    DEALER_AND_OPERATOR_OF_HEAVY_EQUIPMENT: {
      code: 'DEALER_AND_OPERATOR_OF_HEAVY_EQUIPMENT',
      id: 1065,
      value: 'Dealer and Operator of Heavy Equipment'
    },
    MANUFACTURING_OF_SOLAR_STRUCTURES_AND_MODULES: {
      code: 'MANUFACTURING_OF_SOLAR_STRUCTURES_AND_MODULES',
      id: 948,
      value: 'Manufacturing of Solar Structures and Modules'
    },
    MANUFACTURER_OF_IODINE_DERIVATIVES: {
      code: 'MANUFACTURER_OF_IODINE_DERIVATIVES',
      id: 1080,
      value: 'Manufacturer of Iodine Derivatives'
    },
    MANUFACTURING_OF_LUBRICANTS: {
      code: 'MANUFACTURING_OF_LUBRICANTS',
      id: 1079,
      value: 'Manufacturing of Lubricants'
    },
    PORTS_AND_MARINE_CONSTRUCTION_CONTRACTING: {
      code: 'PORTS_AND_MARINE_CONSTRUCTION_CONTRACTING',
      id: 1085,
      value: 'Ports and Marine Construction Contracting'
    },
    TRADING_OF_SCRAP_METALS: {
      code: 'TRADING_OF_SCRAP_METALS',
      id: 1068,
      value: 'Trading of Scrap Metals'
    },
    DISTRIBUTOR_OF_IT_PRODUCTS_AND_ELECTRONICS: {
      code: 'DISTRIBUTOR_OF_IT_PRODUCTS_AND_ELECTRONICS',
      id: 1063,
      value: 'Distributor of IT Products and Electronics'
    },
    TRADING_OF_POLYMERS: {
      code: 'TRADING_OF_POLYMERS',
      id: 1070,
      value: 'Trading of Polymers'
    },
    DISTRIBUTOR_OF_PHARMACEUTICAL_PRODUCTS: {
      code: 'DISTRIBUTOR_OF_PHARMACEUTICAL_PRODUCTS',
      id: 1077,
      value: 'Distributor of Pharmaceutical Products'
    },
    MANUFACTURING_OF_PVC_LEATHER_AND_SHEETS: {
      code: 'MANUFACTURING_OF_PVC_LEATHER_AND_SHEETS',
      id: 1081,
      value: 'Manufacturing of PVC Leather and Sheets'
    },
    EPCC_ENGINEERING_PROCUREMENT_CONSTRUCTION: {
      code: 'EPCC_ENGINEERING_PROCUREMENT_CONSTRUCTION',
      id: 1084,
      value: 'Engineering, Procurement, Construction and Commissioning (EPCC)'
    },
    OIL_AND_GAS_FIELD_EQUIPMENT_MANUFACTURING: {
      code: 'OIL_AND_GAS_FIELD_EQUIPMENT_MANUFACTURING',
      id: 1078,
      value: 'Oil and Gas Field Equipment Manufacturing'
    },
    MANUFACTURER_OF_AUTO_AND_AUTO_COMPONENTS: {
      code: 'MANUFACTURER_OF_AUTO_AND_AUTO_COMPONENTS',
      id: 1061,
      value: 'Manufacturer of Auto and Auto Components'
    },
    MANUFACTURER_OF_FOOD_AND_BEVERAGE: {
      code: 'MANUFACTURER_OF_FOOD_AND_BEVERAGE',
      id: 1066,
      value: 'Manufacturer of Food and Beverage'
    },
    MANUFACTURING_COFFEE_AND_HERBAL_EXTRACTS: {
      code: 'MANUFACTURING_COFFEE_AND_HERBAL_EXTRACTS',
      id: 1069,
      value: 'Manufacturing Coffee and Herbal Extracts'
    },
    MANUFACTURER_OF_ELECTRICAL_PRODUCTS: {
      code: 'MANUFACTURER_OF_ELECTRICAL_PRODUCTS',
      id: 1083,
      value: 'Manufacturer of Electrical Products'
    },
    OTHERS: {
      code: 'OTHERS',
      id: 134,
      value: 'Others'
    },
  },

  MAWANI_BUSINESS_SECTOR_DETAILS: {
    AEROSPACE_DEFENCE: {
      code: 'AEROSPACE_DEFENCE',
      id: 121,
      value: 'Aerospace & Defense'
    },
    AGRICULTURE: {
      code: 'AGRICULTURE',
      id: 122,
      value: 'Agriculture'
    },
    AGRI_COMMODITIES: {
      code: 'AGRI_COMMODITIES',
      id: 123,
      value: 'Agri-Commodities'
    },
    ALTERNATIVE_ENERGY: {
      code: 'ALTERNATIVE_ENERGY',
      id: 124,
      value: 'Alternative Energy'
    },
    AUTO_DISTRIBUTOR: {
      code: "AUTO_DISTRIBUTOR",
      id: 1155,
      value: "Auto Distributor",
    },
    CONTRACTOR_INTERIOR_FIT: {
      code: "CONTRACTOR_INTERIOR_FIT",
      id: 1156,
      value: "Contractor for Interior Fit Out works"
    },
    AUTOMOBILES_COMPONENTS: {
      code: 'AUTOMOBILES_COMPONENTS',
      id: 125,
      value: 'Automobiles & Components'
    },
    AUTOMOBILES_PARTS: {
      code: 'AUTOMOBILES_PARTS',
      id: 126,
      value: 'Automobiles & Parts'
    },
    BEVERAGES: {
      code: 'BEVERAGES',
      id: 127,
      value: 'Beverages',
    },
    CHEMICALS: {
      code: 'CHEMICALS',
      id: 128,
      value: 'Chemicals'
    },
    COMMEERCIAL_SERVICES_ANS_DISTRIBUTORS: {
      code: 'COMMEERCIAL_SERVICES_ANS_DISTRIBUTORS',
      id: 145,
      value: 'Commercial Services & Distributors'
    },
    CONSTRUCTION: {
      code: 'CONSTRUCTION',
      id: 146,
      value: 'Construction'
    },
    CONSTRUCTION_AND_MATERIALS: {
      code: 'CONSTRUCTION_AND_MATERIALS',
      id: 147,
      value: 'Construction & Materials'
    },
    EDUCATION: {
      code: 'EDUCATION',
      id: 148,
      value: 'Education'
    },
    ELECTRICAL_EQUIPMENT_AND_APPLIANCES: {
      code: 'ELECTRICAL_EQUIPMENT_AND_APPLIANCES',
      id: 149,
      value: 'Electrical Equipment & Appliances'
    },
    ELECTRONIC_EQUIPMENT_AND_COMPONENTS: {
      code: 'ELECTRONIC_EQUIPMENT_AND_COMPONENTS',
      id: 150,
      value: 'Electronic Equipment & Components'
    },
    ENERGY_EQUIPMENT_AND_SERVICES: {
      code: 'ENERGY_EQUIPMENT_AND_SERVICES',
      id: 151,
      value: 'Energy Equipment & Services'
    },
    FINANCIAL_SERVICES: {
      code: 'FINANCIAL_SERVICES',
      id: 152,
      value: 'Financial Services'
    },
    FOOD_DISTRIBUTORS: {
      code: 'FOOD_DISTRIBUTORS',
      id: 153,
      value: 'Food Distributors'
    },
    FOOD_PRODUCERS: {
      code: 'FOOD_PRODUCERS',
      id: 154,
      value: 'Food Producers'
    },
    FORESTRY: {
      code: 'FORESTRY',
      id: 155,
      value: 'Forestry'
    },
    SHIPPING_FREIGHT_AND_LOGISTICS: {
      code: 'SHIPPING_FREIGHT_AND_LOGISTICS',
      id: 156,
      value: 'Shipping, Freight & Logistics'
    },
    GENERAL_INDUSTRIALS: {
      code: 'GENERAL_INDUSTRIALS',
      id: 157,
      value: 'General Industrials'
    },
    HEALTH_CARE_SERVICES: {
      code: 'HEALTH_CARE_SERVICES',
      id: 158,
      value: 'Health Care Services'
    },
    HOTELS_AND_RESTAURANTS: {
      code: 'HOTELS_AND_RESTAURANTS',
      id: 159,
      value: 'Hotels & Restaurants'
    },
    HOUSEHOLD_PRODUCTS: {
      code: 'HOUSEHOLD_PRODUCTS',
      id: 160,
      value: 'Household Products'
    },
    INDUSTRIAL_MATERIALS: {
      code: 'INDUSTRIAL_MATERIALS',
      id: 161,
      value: 'Industrial Materials'
    },
    INDUSTRIAL_METALS_AND_MINING: {
      code: 'INDUSTRIAL_METALS_AND_MINING',
      id: 162,
      value: 'Industrial Metals & Mining'
    },
    INDUSTRIAL_TRANSPORTATION: {
      code: 'INDUSTRIAL_TRANSPORTATION',
      id: 163,
      value: 'Industrial Transportation'
    },
    RETAIL_INTERNET_AND_DIRECT_MARKETING: {
      code: 'RETAIL_INTERNET_AND_DIRECT_MARKETING',
      id: 164,
      value: 'Retail: Internet & Direct Marketing'
    },
    LEISURE_GOODS_AND_TOYS: {
      code: 'LEISURE_GOODS_AND_TOYS',
      id: 165,
      value: 'Leisure Goods & Toys'
    },
    LUXURY_GOODS: {
      code: 'LUXURY_GOODS',
      id: 166,
      value: 'Luxury Goods'
    },
    MACHINERY: {
      code: 'MACHINERY',
      id: 167,
      value: 'Machinery'
    },
    MEDIA_AND_ENTERTAINMENT: {
      code: 'MEDIA_AND_ENTERTAINMENT',
      id: 168,
      value: 'Media & Entertainment'
    },
    MEDICAL_EQUIPMENT_AND_SERVICES: {
      code: 'MEDICAL_EQUIPMENT_AND_SERVICES',
      id: 169,
      value: 'Medical Equipment & Services'
    },
    METALS_AND_MINING: {
      code: 'METALS_AND_MINING',
      id: 170,
      value: 'Metals & Mining'
    },
    OIL_GAS_AND_CONSUMABLE_FUELS: {
      code: 'OIL_GAS_AND_CONSUMABLE_FUELS',
      id: 171,
      value: 'Oil Gas & Consumable Fuels'
    },
    PERSONAL_PRODUCTS: {
      code: 'PERSONAL_PRODUCTS',
      id: 172,
      value: 'Personal Products'
    },
    PHARMACEUTICALS_AND_BIOTECHNOLOGY: {
      code: 'PHARMACEUTICALS_AND_BIOTECHNOLOGY',
      id: 173,
      value: 'Pharmaceuticals & Biotechnology'
    },
    PRECIOUS_METALS_AND_STONES: {
      code: 'PRECIOUS_METALS_AND_STONES',
      id: 174,
      value: 'Precious Metals & Stones'
    },
    RETAIL_DISTRIBUTOR: {
      code: 'RETAIL_DISTRIBUTOR',
      id: 175,
      value: 'Retail: Distributor'
    },
    RETAILER_OTHER: {
      code: 'RETAILER_OTHER',
      id: 176,
      value: 'Retailer Other'
    },
    SOFTWARE_AND_COMPUTER_SERVICES: {
      code: 'SOFTWARE_AND_COMPUTER_SERVICES',
      id: 177,
      value: 'Software & Computer Services'
    },
    TECHNOLOGY_HARDWARE_AND_EQUIPMENT: {
      code: 'TECHNOLOGY_HARDWARE_AND_EQUIPMENT',
      id: 178,
      value: 'Technology Hardware & Equipment'
    },
    TELECOMMUNICATIONS_EQUIPMENT: {
      code: 'TELECOMMUNICATIONS_EQUIPMENT',
      id: 179,
      value: 'Telecommunications Equipment'
    },
    TELECOMMUNICATIONS_SERVICE_PROVIDERS: {
      code: 'TELECOMMUNICATIONS_SERVICE_PROVIDERS',
      id: 180,
      value: 'Telecommunications Service Providers'
    },
    TEXTILES_AND_APPAREL: {
      code: 'TEXTILES_AND_APPAREL',
      id: 181,
      value: 'Textiles & Apparel'
    },
    TOBACCO: {
      code: 'TOBACCO',
      id: 182,
      value: 'Tobacco'
    },
    TRADING_COMPANY_DISTRIBUTOR: {
      code: 'TRADING_COMPANY_DISTRIBUTOR',
      id: 183,
      value: 'Trading Company/ Distributor'
    },
    TRAVEL_AND_TOURISM: {
      code: 'TRAVEL_AND_TOURISM',
      id: 184,
      value: 'Travel & Tourism'
    },
    UTILITIES: {
      code: 'UTILITIES',
      id: 185,
      value: 'Utilities'
    },
    MANUFACTURING_OF_SOLAR_STRUCTURES_AND_MODULES: {
      code: 'MANUFACTURING_OF_SOLAR_STRUCTURES_AND_MODULES',
      id: 948,
      value: 'Manufacturing of Solar Structures and Modules'
    },
    PROCESSING_AND_TRADING_OF_TOBACCO: {
      code: 'PROCESSING_AND_TRADING_OF_TOBACCO',
      id: 1059,
      value: 'Processing and Trading of Tobacco'
    },
    PROC_TRADING_AGRICULTURAL_COMMODITIES: {
      code: 'PROC_TRADING_AGRICULTURAL_COMMODITIES',
      id: 1060,
      value: 'Processing and Trading of Agricultural Commodities'
    },
    MANUFACTURER_OF_AUTO_AND_AUTO_COMPONENTS: {
      code: 'MANUFACTURER_OF_AUTO_AND_AUTO_COMPONENTS',
      id: 1061,
      value: 'Manufacturer of Auto and Auto Components'
    },
    MANUFACTURER_OF_STEEL_PRODUCTS: {
      code: 'MANUFACTURER_OF_STEEL_PRODUCTS',
      id: 1062,
      value: 'Manufacturer of Steel Products'
    },
    DISTRIBUTOR_OF_IT_PRODUCTS_AND_ELECTRONICS: {
      code: 'DISTRIBUTOR_OF_IT_PRODUCTS_AND_ELECTRONICS',
      id: 1063,
      value: 'Distributor of IT Products and Electronics'
    },
    ASSEMBLY_TRADING_OF_LEAD_ACID_CELLSBATTERY: {
      code: 'ASSEMBLY_TRADING_OF_LEAD_ACID_CELLSBATTERY',
      id: 1064,
      value: 'Assembly & Trading of Lead Acid Cells/Battery'
    },
    DEALER_AND_OPERATOR_OF_HEAVY_EQUIPMENT: {
      code: 'DEALER_AND_OPERATOR_OF_HEAVY_EQUIPMENT',
      id: 1065,
      value: 'Dealer and Operator of Heavy Equipment'
    },
    MANUFACTURER_OF_FOOD_AND_BEVERAGE: {
      code: 'MANUFACTURER_OF_FOOD_AND_BEVERAGE',
      id: 1066,
      value: 'Manufacturer of Food and Beverage'
    },
    TRADING_OF_CHEMICALS: {
      code: 'TRADING_OF_CHEMICALS',
      id: 1067,
      value: 'Trading of Chemicals'
    },
    TRADING_OF_SCRAP_METALS: {
      code: 'TRADING_OF_SCRAP_METALS',
      id: 1068,
      value: 'Trading of Scrap Metals'
    },
    MANUFACTURING_COFFEE_AND_HERBAL_EXTRACTS: {
      code: 'MANUFACTURING_COFFEE_AND_HERBAL_EXTRACTS',
      id: 1069,
      value: 'Manufacturing Coffee and Herbal Extracts'
    },
    TRADING_OF_POLYMERS: {
      code: 'TRADING_OF_POLYMERS',
      id: 1070,
      value: 'Trading of Polymers'
    },
    MFG_DISTRIBUTOR_AGROCHEMICALS_FERTILIZERS: {
      code: 'MFG_DISTRIBUTOR_AGROCHEMICALS_FERTILIZERS',
      id: 1071,
      value: 'Manufacturer and Distributor of Agrochemicals/Fertilizers'
    },
    EDIBLE_OIL_REFINERY_AND_PACKAGING: {
      code: 'EDIBLE_OIL_REFINERY_AND_PACKAGING',
      id: 1072,
      value: 'Edible Oil Refinery and Packaging'
    },
    MANUFACTURING_OF_ALLOYS: {
      code: 'MANUFACTURING_OF_ALLOYS',
      id: 1073,
      value: 'Manufacturing of Alloys'
    },
    TRADER_OF_FOOD_AND_BEVERAGES: {
      code: 'TRADER_OF_FOOD_AND_BEVERAGES',
      id: 1074,
      value: 'Trader of Food and Beverages'
    },
    MFG_AND_TRADING_OF_BUILDING_MATERIALS: {
      code: 'MFG_AND_TRADING_OF_BUILDING_MATERIALS',
      id: 1139,
      value: 'Manufacturing and Trading of Building Materials'
    },
    MANUFACTURER_OF_PACKAGING_PRODUCTS: {
      code: 'MANUFACTURER_OF_PACKAGING_PRODUCTS',
      id: 1076,
      value: 'Manufacturer of Packaging Products'
    },
    DISTRIBUTOR_OF_PHARMACEUTICAL_PRODUCTS: {
      code: 'DISTRIBUTOR_OF_PHARMACEUTICAL_PRODUCTS',
      id: 1077,
      value: 'Distributor of Pharmaceutical Products'
    },
    OIL_AND_GAS_FIELD_EQUIPMENT_MANUFACTURING: {
      code: 'OIL_AND_GAS_FIELD_EQUIPMENT_MANUFACTURING',
      id: 1078,
      value: 'Oil and Gas Field Equipment Manufacturing'
    },
    MANUFACTURING_OF_LUBRICANTS: {
      code: 'MANUFACTURING_OF_LUBRICANTS',
      id: 1079,
      value: 'Manufacturing of Lubricants'
    },
    MANUFACTURER_OF_IODINE_DERIVATIVES: {
      code: 'MANUFACTURER_OF_IODINE_DERIVATIVES',
      id: 1080,
      value: 'Manufacturer of Iodine Derivatives'
    },
    MANUFACTURING_OF_PVC_LEATHER_AND_SHEETS: {
      code: 'MANUFACTURING_OF_PVC_LEATHER_AND_SHEETS',
      id: 1081,
      value: 'Manufacturing of PVC Leather and Sheets'
    },
    MFG_HYGIENE_PERSONAL_CARE_PRODUCTS: {
      code: 'MFG_HYGIENE_PERSONAL_CARE_PRODUCTS',
      id: 1082,
      value: 'Manufacturer of Hygiene and Personal Care Products'
    },
    MANUFACTURER_OF_ELECTRICAL_PRODUCTS: {
      code: 'MANUFACTURER_OF_ELECTRICAL_PRODUCTS',
      id: 1083,
      value: 'Manufacturer of Electrical Products'
    },
    EPCC_ENGINEERING_PROCUREMENT_CONSTRUCTION: {
      code: 'EPCC_ENGINEERING_PROCUREMENT_CONSTRUCTION',
      id: 1084,
      value: 'Engineering, Procurement, Construction and Commissioning (EPCC)'
    },
    PORTS_AND_MARINE_CONSTRUCTION_CONTRACTING: {
      code: 'PORTS_AND_MARINE_CONSTRUCTION_CONTRACTING',
      id: 1085,
      value: 'Ports and Marine Construction Contracting'
    },
    BULK_COMMODITY_SUPPLY: {
      code: 'BULK_COMMODITY_SUPPLY',
      id: 1086,
      value: 'Bulk Commodity Supply'
    },
    TRADER_OF_READYMADE_GARMENTS: {
      code: 'TRADER_OF_READYMADE_GARMENTS',
      id: 1087,
      value: 'Trader of Readymade Garments'
    },
    TRADING_AND_DISTRIBUTING_FMCG_PRODUCTS: {
      code: 'TRADING_AND_DISTRIBUTING_FMCG_PRODUCTS',
      id: 1140,
      value: 'Trading and distributing FMCG Products'
    },
    OTHER: {
      code: 'OTHER',
      id: 134,
      value: 'Other'
    },
  },

  MAWANI_BUSINESS_SECTOR_LIST: [
    'AEROSPACE_DEFENCE', 'AGRICULTURE', 'AGRI_COMMODITIES', 'ALTERNATIVE_ENERGY', 'AUTO_DISTRIBUTOR', 'AUTOMOBILES_COMPONENTS', 'AUTOMOBILES_PARTS', 'BEVERAGES', 'CHEMICALS', 'COMMEERCIAL_SERVICES_ANS_DISTRIBUTORS', 'CONSTRUCTION', 'CONSTRUCTION_AND_MATERIALS', 'CONTRACTOR_INTERIOR_FIT',
    'EDUCATION', 'ELECTRICAL_EQUIPMENT_AND_APPLIANCES', 'ELECTRONIC_EQUIPMENT_AND_COMPONENTS', 'ENERGY_EQUIPMENT_AND_SERVICES', 'FINANCIAL_SERVICES', 'FOOD_DISTRIBUTORS', 'FOOD_PRODUCERS', 'FORESTRY', 'SHIPPING_FREIGHT_AND_LOGISTICS',
    'GENERAL_INDUSTRIALS', 'HEALTH_CARE_SERVICES', 'HOTELS_AND_RESTAURANTS', 'HOUSEHOLD_PRODUCTS', 'INDUSTRIAL_MATERIALS', 'INDUSTRIAL_METALS_AND_MINING', 'INDUSTRIAL_TRANSPORTATION', 'RETAIL_INTERNET_AND_DIRECT_MARKETING', 'LEISURE_GOODS_AND_TOYS',
    'LUXURY_GOODS', 'MACHINERY', 'MEDIA_AND_ENTERTAINMENT', 'MEDICAL_EQUIPMENT_AND_SERVICES', 'METALS_AND_MINING', 'OIL_GAS_AND_CONSUMABLE_FUELS', 'PERSONAL_PRODUCTS', 'PHARMACEUTICALS_AND_BIOTECHNOLOGY', 'PRECIOUS_METALS_AND_STONES',
    'RETAIL_DISTRIBUTOR', 'RETAILER_OTHER', 'SOFTWARE_AND_COMPUTER_SERVICES', 'TECHNOLOGY_HARDWARE_AND_EQUIPMENT', 'TELECOMMUNICATIONS_EQUIPMENT', 'TELECOMMUNICATIONS_SERVICE_PROVIDERS', 'TEXTILES_AND_APPAREL', 'TOBACCO', 'TRADING_COMPANY_DISTRIBUTOR',
    'TRAVEL_AND_TOURISM', 'UTILITIES', 'MANUFACTURING_OF_SOLAR_STRUCTURES_AND_MODULES', 'PROCESSING_AND_TRADING_OF_TOBACCO', 'PROC_TRADING_AGRICULTURAL_COMMODITIES', 'MANUFACTURER_OF_AUTO_AND_AUTO_COMPONENTS', 'MANUFACTURER_OF_STEEL_PRODUCTS',
    'DISTRIBUTOR_OF_IT_PRODUCTS_AND_ELECTRONICS', 'ASSEMBLY_TRADING_OF_LEAD_ACID_CELLSBATTERY', 'DEALER_AND_OPERATOR_OF_HEAVY_EQUIPMENT', 'MANUFACTURER_OF_FOOD_AND_BEVERAGE', 'TRADING_OF_CHEMICALS', 'TRADING_OF_SCRAP_METALS',
    'MANUFACTURING_COFFEE_AND_HERBAL_EXTRACTS', 'TRADING_OF_POLYMERS', 'MFG_DISTRIBUTOR_AGROCHEMICALS_FERTILIZERS', 'EDIBLE_OIL_REFINERY_AND_PACKAGING', 'MANUFACTURING_OF_ALLOYS', 'TRADER_OF_FOOD_AND_BEVERAGES',
    'MFG_AND_TRADING_OF_BUILDING_MATERIALS', 'MANUFACTURER_OF_PACKAGING_PRODUCTS', 'DISTRIBUTOR_OF_PHARMACEUTICAL_PRODUCTS', 'OIL_AND_GAS_FIELD_EQUIPMENT_MANUFACTURING', 'MANUFACTURING_OF_LUBRICANTS', 'MANUFACTURER_OF_IODINE_DERIVATIVES',
    'MANUFACTURING_OF_PVC_LEATHER_AND_SHEETS', 'MFG_HYGIENE_PERSONAL_CARE_PRODUCTS', 'MANUFACTURER_OF_ELECTRICAL_PRODUCTS', 'EPCC_ENGINEERING_PROCUREMENT_CONSTRUCTION', 'PORTS_AND_MARINE_CONSTRUCTION_CONTRACTING',
    'BULK_COMMODITY_SUPPLY', 'TRADER_OF_READYMADE_GARMENTS', 'TRADING_AND_DISTRIBUTING_FMCG_PRODUCTS', 'OTHER'
  ],

  DPW_COMPANIES_LIST: [
    'SEA_RATES', 'DIGITAL_FREIGHT_ALLIANCE', 'DRAGON_MART', 'DUBUY_COM', 'CARGOES_FLOW', 'CARGOES_RUNNER', 'CARGOES_TOS', 'CARGOES_COMMUNITY', 'CARGOES_CUSTOMS', 'CARGOES_ZONE_MANAGEMENT_SYSYTEM', 'OTHER'
  ],

  DPW_COMPANY_CODE_MAP: {
    SEA_RATES: {
      code: 'SEA_RATES',
      id: 23,
      value: 'SeaRates'
    },
    DIGITAL_FREIGHT_ALLIANCE: {
      code: 'DIGITAL_FREIGHT_ALLIANCE',
      id: 24,
      value: 'Digital Freight Alliance'
    },
    DRAGON_MART: {
      code: 'DRAGON_MART',
      id: 25,
      value: 'Dragon Mart'
    },
    DUBUY_COM: {
      code: 'DUBUY_COM',
      id: 26,
      value: 'Dubuy.com'
    },
    CARGOES_FLOW: {
      code: 'CARGOES_FLOW',
      id: 27,
      value: 'Cargoes Flow'
    },
    CARGOES_RUNNER: {
      code: 'CARGOES_RUNNER',
      id: 28,
      value: 'Cargoes Runner'
    },
    CARGOES_TOS: {
      code: 'CARGOES_TOS',
      id: 29,
      value: 'Cargoes TOS'
    },
    CARGOES_COMMUNITY: {
      code: 'CARGOES_COMMUNITY',
      id: 30,
      value: 'Cargoes Commumity'
    },
    CARGOES_CUSTOMS: {
      code: 'CARGOES_CUSTOMS',
      id: 31,
      value: 'Cargoes Customs'
    },
    CARGOES_ZONE_MANAGEMENT_SYSYTEM: {
      code: 'CARGOES_ZONE_MANAGEMENT_SYSYTEM',
      id: 32,
      value: 'Cargoes Zone Management System'
    },
    OTHER: {
      code: 'OTHER',
      id: 133,
      value: 'Other'
    }
  },

  EXISTING_CUSTOMER_ASSOCIATED_YEARS: [
    'LESS_THAN_ONE_YEAR', 'ONE_TO_FOUR_YEARS', 'FOUR_TO_TEN_YEARS', 'GREATERTHAN_TEN_YEARS'
  ],

  ASSOCIATED_YEARS_MAP: {
    LESS_THAN_ONE_YEAR: {
      code: 'LESS_THAN_ONE_YEAR',
      id: 117,
      value: '<1 year'
    },
    ONE_TO_FOUR_YEARS: {
      code: 'ONE_TO_FOUR_YEARS',
      id: 118,
      value: '1-4 years'
    },
    FOUR_TO_TEN_YEARS: {
      code: 'FOUR_TO_TEN_YEARS',
      id: 119,
      value: '4-10 years'
    },
    GREATERTHAN_TEN_YEARS: {
      code: 'GREATERTHAN_TEN_YEARS',
      id: 120,
      value: '>10 years'
    }
  },

  ANNUAL_TRANSACTIONS_LIST: ['UPTO_TEN_MILLION', 'TEN_TO_FORTY_MILLION', 'GREATERTHAN_FORTY_MILLION'],

  ANNUAL_TRANSACTIONS_MAP: {
    UPTO_TEN_MILLION: {
      code: 'UPTO_TEN_MILLION',
      id: 43,
      value: 'Up to $10 million'
    },
    TEN_TO_FORTY_MILLION: {
      code: 'TEN_TO_FORTY_MILLION',
      id: 44,
      value: '$10-40 million'
    },
    GREATERTHAN_FORTY_MILLION: {
      code: 'GREATERTHAN_FORTY_MILLION',
      id: 45,
      value: '> $40 million'
    }
  },

  TRANSACTIONS_COUNT_LIST: ['ONE_TO_THREE', 'FOUR_TO_TEN', 'GREATER_THAN_TEN'],

  TRANSACTIONS_COUNT_MAP: {
    ONE_TO_THREE: {
      code: 'ONE_TO_THREE',
      id: 46,
      value: '1-3'
    },
    FOUR_TO_TEN: {
      code: 'FOUR_TO_TEN',
      id: 47,
      value: '4-10'
    },
    GREATER_THAN_TEN: {
      code: 'GREATER_THAN_TEN',
      id: 48,
      value: '>10'
    }
  },

  MONTHLY_TRANSACTION_LIST: ['LESSTHAN_TEN_MILLION', 'ONE_TO_FIVE_MILLION', 'GREATERTHAN_FIVE_MILLION'],

  MONTHLY_TRANSACTION_MAP: {
    LESSTHAN_TEN_MILLION: {
      code: 'LESSTHAN_TEN_MILLION',
      id: 49,
      value: '<$1 million'
    },
    ONE_TO_FIVE_MILLION: {
      code: 'ONE_TO_FIVE_MILLION',
      id: 50,
      value: '$1-$5 million'
    },
    GREATERTHAN_FIVE_MILLION: {
      code: 'GREATERTHAN_FIVE_MILLION',
      id: 51,
      value: '>$5 million'
    }
  },

  CONSOLIDATION_LIST: ['MOSTLY', 'SOMETIMES', 'NEVER', 'DONOT_KNOW'],

  CONSOLIDATION_MAP: {
    MOSTLY: {
      code: 'MOSTLY',
      id: 60,
      value: 'Mostly'
    },
    SOMETIMES: {
      code: 'SOMETIMES',
      id: 61,
      value: 'Sometimes'
    },
    NEVER: {
      code: 'NEVER',
      id: 62,
      value: 'Never'
    },
    DONOT_KNOW: {
      code: 'DONOT_KNOW',
      id: 63,
      value: 'Don’t know, cargoes handled by FF/Importer'
    }
  },

  REGIONS_LIST: ['APAC', 'CENTRAL_AFRICA', 'CIS', 'EAST_AFRICA', 'EAST_ASIA', 'EU_and_UK', 'GCC', 'LATIN_AMERICA', 'MENA', 'SOUTHERN_AFRICA', 'SUB_CONTINENT',
    'USA_AND_CANADA', 'WEST_AFRICA', 'OTHER'],

  REGIONS_NAME_LIST: ['APAC', 'CENTRAL AFRICA', 'CIS', 'EAST AFRICA', 'EAST ASIA', 'EU & UK', 'GCC', 'LATIN AMERICA', 'MENA', 'SOUTHERN AFRICA', 'SUB CONTINENT',
    'USA & CANADA', 'WEST AFRICA', 'Other'],

  REGIONS_MAP: {
    APAC: {
      code: 'APAC',
      id: 110,
      value: 'APAC'
    },
    CENTRAL_AFRICA: {
      code: 'CENTRAL_AFRICA',
      id: 108,
      value: 'CENTRAL AFRICA'
    },
    CIS: {
      code: 'CIS',
      id: 113,
      value: 'CIS'
    },
    EAST_AFRICA: {
      code: 'EAST_AFRICA',
      id: 107,
      value: 'EAST AFRICA'
    },
    EAST_ASIA: {
      code: 'EAST_ASIA',
      id: 112,
      value: 'EAST ASIA'
    },
    EU_and_UK: {
      code: 'EU_and_UK',
      id: 116,
      value: 'EU & UK'
    },
    GCC: {
      code: 'GCC',
      id: 104,
      value: 'GCC'
    },
    LATIN_AMERICA: {
      code: 'LATIN_AMERICA',
      id: 114,
      value: 'LATIN AMERICA'
    },
    MENA: {
      code: 'MENA',
      id: 105,
      value: 'MENA'
    },
    SOUTHERN_AFRICA: {
      code: 'SOUTHERN_AFRICA',
      id: 109,
      value: 'SOUTHERN AFRICA'
    },
    SUB_CONTINENT: {
      code: 'SUB_CONTINENT',
      id: 111,
      value: 'SUB CONTINENT'
    },
    USA_AND_CANADA: {
      code: 'USA_AND_CANADA',
      id: 115,
      value: 'USA & CANADA'
    },
    WEST_AFRICA: {
      code: 'WEST_AFRICA',
      id: 106,
      value: 'WEST AFRICA'
    },
    OTHER: {
      code: 'OTHER',
      id: 138,
      value: 'Other'
    },
  },

  MAWANI_COMMODITY_LIST_NAME_TO_CODE_MAPPING: {
    'Aluminium': 'ALUMINIUM',
    'Animal Fodder': 'ANIMAL_FODDER',
    'Animal Products': 'ANIMAL_PRODUCTS',
    'Apparel': 'APPAREL',
    'Arms': 'ARMS',
    'Asbestos': 'ASBESTOS',
    'Ash': 'ASH',
    'Auto - Motor Vehicles': 'AUTO_MOTOR_VEHICLES',
    'Auto - Parts': 'AUTO_PARTS',
    'Beverages': 'BEVERAGES',
    'Building Materials': 'BUILDING_MATERIALS',
    'Carpets & Tapestries': 'CARPETS_TAPESTRIES',
    'Cement': 'CEMENT',
    'Charcoal': 'CHARCOAL',
    'Chemicals': 'CHEMICALS',
    'Cigarettes': 'CIGARETTES',
    'Cocoa': 'COCOA',
    'Coffee': 'COFEE',
    'Components': 'COMPONENTS',
    'Copper': 'COPPER',
    'Cosmetics': 'COSMETICS',
    'Consumer Electronics': 'COSUMER_ELECTRONICS',
    'Cotton': 'COTTON',
    'Diamonds & Gemstones': 'DIAMONDS_AND_GEMSTONES',
    'Electrical Equipment': 'ELECTRICAL_EQUIPMENT',
    'Electronic Equipment': 'ELECTRONIC_EQUIPMENT',
    'Explosives': 'EXPLOSIVES',
    'Fertilisers': 'FERTILISERS',
    'Footwear': 'FOOTWEAR',
    'Furniture': 'FURNITURE',
    'Games': 'GAMES',
    'Gas': 'GAS',
    'Glass': 'GLASS',
    'Hazardous Goods': 'HAZARDOUS_GOODS',
    'Household Appliances': 'HOUSEHOLD_APPLIANCES',
    'Household Products': 'HOUSEHOLD_PRODUCTS',
    'Iron & Steel': 'IRON_AND_STEEL',
    'Lead': 'LEAD',
    'Lubricants': 'LUBRICANTS',
    'Machinery': 'MACHINERY',
    'Mechanical Equipment': 'MECHANICAL_EQUIPMENT',
    'Medical Instruments': 'MEDICAL_INSTRUMENTS',
    'Mineral Fuel': 'MINERAL_FUEL',
    'Mineral Oils': 'MINERAL_OILS',
    'Nickel': 'NICKEL',
    'Oil': 'OIL',
    'Ore': 'ORE',
    'Other': 'OTHER',
    'Other agri-commodities': 'OTHER_AGRI_COMMODITIES',
    'Packaging': 'PACKAGING',
    'Paint': 'PAINT',
    'Paper': 'PAPER',
    'Perfume': 'PERFUME',
    'Personal Products': 'PERSONAL_PRODUCTS',
    'Plastics': 'PLASTICS',
    'Precious Metals & Minerals': 'PRECIOUS_METALS_AND_MINERALS',
    'Produce - Dairy': 'PRODUCE_DAIRY',
    'Produce - Fats & Oils': 'PRODUCE_FATS_AND_OILS',
    'Produce - Fish': 'PRODUCE_FISH',
    'Produce - Flowers': 'PRODUCE_FLOWERS',
    'Produce - Fruit & Nuts': 'PRODUCE_FRUIT_AND_NUTS',
    'Produce - Grains & Cereals': 'PRODUCE_GRAINS_AND_CEREALS',
    'Produce - Meat': 'PRODUCE_MEAT',
    'Produce - Other Perishables': 'PRODUCE_OTHER_PERISHABLES',
    'Produce - Spices': 'PRODUCE_SPICES',
    'Produce - Veg': 'PRODUCE_VEG',
    'Rubber': 'RUBBER',
    'Salt': 'SALT',
    'Seeds': 'SEEDS',
    'Silk': 'SILK',
    'Stone': 'STONE',
    'Sugar': 'SUGAR',
    'Sulphur': 'SULPHUR',
    'Tea': 'TEA',
    'Textiles': 'TEXTILES',
    'Tin': 'TIN',
    'Tobacco': 'TOBACCO',
    'Tools': 'TOOLS',
    'Toys': 'TOYS',
    'Tyres': 'TYRES',
    'Wheat': 'WHEAT',
    'Wood': 'WOOD',
    'Zinc': 'ZINC'
  },

  MAWANI_COMMODITY_LIST_CODE_TO_NAME_MAPPING: {
    'ALUMINIUM': 'Aluminium',
    'ANIMAL_FODDER': 'Animal Fodder',
    'ANIMAL_PRODUCTS': 'Animal Products',
    'APPAREL': 'Apparel',
    'ARMS': 'Arms',
    'ASBESTOS': 'Asbestos',
    'ASH': 'Ash',
    'AUTO_MOTOR_VEHICLES': 'Auto - Motor Vehicles',
    'AUTO_PARTS': 'Auto - Parts',
    'BEVERAGES': 'Beverages',
    'BUILDING_MATERIALS': 'Building Materials',
    'CARPETS_TAPESTRIES': 'Carpets & Tapestries',
    'CEMENT': 'Cement',
    'CHARCOAL': 'Charcoal',
    'CHEMICALS': 'Chemicals',
    'CIGARETTES': 'Cigarettes',
    'COCOA': 'Cocoa',
    'COFEE': 'Coffee',
    'COMPONENTS': 'Components',
    'COPPER': 'Copper',
    'COSMETICS': 'Cosmetics',
    'COSUMER_ELECTRONICS': 'Consumer Electronics',
    'COTTON': 'Cotton',
    'DIAMONDS_AND_GEMSTONES': 'Diamonds & Gemstones',
    'ELECTRICAL_EQUIPMENT': 'Electrical Equipment',
    'ELECTRONIC_EQUIPMENT': 'Electronic Equipment',
    'EXPLOSIVES': 'Explosives',
    'FERTILISERS': 'Fertilisers',
    'FOOTWEAR': 'Footwear',
    'FURNITURE': 'Furniture',
    'GAMES': 'Games',
    'GAS': 'Gas',
    'GLASS': 'Glass',
    'HAZARDOUS_GOODS': 'Hazardous Goods',
    'HOUSEHOLD_APPLIANCES': 'Household Appliances',
    'HOUSEHOLD_PRODUCTS': 'Household Products',
    'IRON_AND_STEEL': 'Iron & Steel',
    'LEAD': 'Lead',
    'LUBRICANTS': 'Lubricants',
    'MACHINERY': 'Machinery',
    'MECHANICAL_EQUIPMENT': 'Mechanical Equipment',
    'MEDICAL_INSTRUMENTS': 'Medical Instruments',
    'MINERAL_FUEL': 'Mineral Fuel',
    'MINERAL_OILS': 'Mineral Oils',
    'NICKEL': 'Nickel',
    'OIL': 'Oil',
    'ORE': 'Ore',
    'OTHER': 'Other',
    'OTHER_AGRI_COMMODITIES': 'Other agri-commodities',
    'PACKAGING': 'Packaging',
    'PAINT': 'Paint',
    'PAPER': 'Paper',
    'PERFUME': 'Perfume',
    'PERSONAL_PRODUCTS': 'Personal Products',
    'PLASTICS': 'Plastics',
    'PRECIOUS_METALS_AND_MINERALS': 'Precious Metals & Minerals',
    'PRODUCE_DAIRY': 'Produce - Dairy',
    'PRODUCE_FATS_AND_OILS': 'Produce - Fats & Oils',
    'PRODUCE_FISH': 'Produce - Fish',
    'PRODUCE_FLOWERS': 'Produce - Flowers',
    'PRODUCE_FRUIT_AND_NUTS': 'Produce - Fruit & Nuts',
    'PRODUCE_GRAINS_AND_CEREALS': 'Produce - Grains & Cereals',
    'PRODUCE_MEAT': 'Produce - Meat',
    'PRODUCE_OTHER_PERISHABLES': 'Produce - Other Perishables',
    'PRODUCE_SPICES': 'Produce - Spices',
    'PRODUCE_VEG': 'Produce - Veg',
    'RUBBER': 'Rubber',
    'SALT': 'Salt',
    'SEEDS': 'Seeds',
    'SILK': 'Silk',
    'STONE': 'Stone',
    'SUGAR': 'Sugar',
    'SULPHUR': 'Sulphur',
    'TEA': 'Tea',
    'TEXTILES': 'Textiles',
    'TIN': 'Tin',
    'Tobacco': 'TOBACCO',
    'TOOLS': 'Tools',
    'TOYS': 'Toys',
    'TYRES': 'Tyres',
    'WHEAT': 'Wheat',
    'WOOD': 'Wood',
    'ZINC': 'Zinc',
  },
  MAWANI_WEALTH_SOURCE_MAPPING: {
    'CASH_BASED_BUSINESS': 'Cash based business',
    'NON_CASH_BASED_BUSINESS': 'Non-cash based business'
  },
  dataTransferKeys: {
    companyPageToRiskAssessment: 'companyPageToriskAssessment',
    companyPageToOngoingMonitoring: 'companyPageToOngoingMonitoring',
    OngoingMonitoring: 'OngoingMonitoring',
    riskRating: 'riskRating'
  }
};
